<valben-header
    [contentType]="contentType"
    [editEnabled]="editEnabled"
    [showContentTabs]="false"
    [hideAddButton]="hrRecordExists"
    (contentTypeChange)="setContentType($event)">
</valben-header>

<div
    class="relative grow overflow-y-auto"
    [ngSwitch]="contentType"
    [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': loading$ | async}">

    @if (loading$ | async) {
        <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div *ngSwitchCase="0">
        @if (!hrRecordExists) {
            <p class="p-4 text-lg text-gray-700">
                Prosječni mjesečni prihod za Hrvatsku nije postavljen. Kliknite <strong>Dodaj</strong> za unos početne vrijednosti.
            </p>
        }
        <valben-table
            (editEvent)="editOnClick($event)"
            [columns]="cols"
            [values]="tableValues"
            [refresh]="refresh"
            [paginator]="false"
            [showHistory]="false">
        </valben-table>
    </div>

    <div *ngSwitchCase="1" class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
        <button class="flex valben-button text-lg ml-auto" (click)="save()">Spremi</button>
        <valben-text-input
            [key]="createAvgMonthlyIncomeKeys.CountryCode"
            [itemObservable]="addItemObservable"
            [update]="noopCountryCodeUpdate"
            title="Šifra države"
            [preview]="true"
            [error]="cErrors[createAvgMonthlyIncomeKeys.CountryCode]"
        ></valben-text-input>
        <valben-number-input
            [key]="createAvgMonthlyIncomeKeys.Income"
            [itemObservable]="addItemObservable"
            [update]="updateAddAverageMonthlyIncome"
            title="Prosječni mjesečni prihod"
            [error]="cErrors[createAvgMonthlyIncomeKeys.Income]"
        ></valben-number-input>
        <div class="flex gap-4 justify-end items-center select-none">
            <button class="valben-button text-lg" (click)="backFromAdd()">Natrag</button>
            <button class="text-lg valben-button" (click)="save()">Spremi</button>
        </div>
    </div>

    <div
        *ngSwitchCase="2"
        class="flex flex-col gap-4 bg-valamargray border-2 static p-4"
        [ngClass]="(loading$ | async) ? 'blur-[2px] pointer-events-none [&_*]:select-none' : ''"
    >
        <button class="flex valben-button text-lg ml-auto" (click)="modify()">Spremi</button>
        <valben-text-input
            [key]="mofifyAvgMonthlyIncomeKeys.CountryCode"
            [itemObservable]="editItemObservable"
            [update]="noopCountryCodeUpdate"
            title="Šifra države"
            [preview]="true"
            [error]="mErrors[mofifyAvgMonthlyIncomeKeys.CountryCode]"
        ></valben-text-input>
        <valben-number-input
            [key]="mofifyAvgMonthlyIncomeKeys.Income"
            [itemObservable]="editItemObservable"
            [update]="updateEditAverageMonthlyIncome"
            title="Prosječni mjesečni prihod"
            [error]="mErrors[mofifyAvgMonthlyIncomeKeys.Income]"
        ></valben-number-input>
        <div class="flex gap-4 justify-end items-center select-none">
            <button class="valben-button text-lg" (click)="backFromEdit()">Natrag</button>
            <button class="valben-button text-lg" (click)="modify()">Spremi</button>
        </div>
    </div>
</div>
